import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
};

const loggedInElsewhereSlice = createSlice({
  name: "loggedInElsewhere",
  initialState,
  reducers: {
    showLoggedInElsewhereModal(state) {
      state.isOpen = true;
    },
    hideLoggedInElsewhereModal(state) {
      state.isOpen = false;
    },
  },
});

export const { showLoggedInElsewhereModal, hideLoggedInElsewhereModal } =
  loggedInElsewhereSlice.actions;

export default loggedInElsewhereSlice.reducer;
